import { vdsUrls, VDS_KEY, VERSION } from "../../constants/ApiUrls";
import { getVdsData } from "../../networkManager/NetworkManager";

export const getGenerationalConsultants = (params) => {
  return getVdsData(
    VDS_KEY +
      VERSION +
      vdsUrls.GENERATIONAL_CONSULTANTS +
      `?BankGroupId=${params.bankGroupId}&BankId=${params.bankId}&branchId=${params.branchId}&productId=${params.productId}&PageSize=${params?.pageSize}&PageNumber=${params?.pageNumber}`
  );
};
